<template>
	<div class="grid-flex-container" v-if="initialized">
		<v-container
			fluid
			class="d-flex flex-column flex-wrap flex-grow-1 overflow-y-auto"
		>
			<edit-user-fields
				:selectedUser="selectedUser"
				:adminFields="true"
				@cancel="cancel"
				@submit="submit"
			/>
		</v-container>

		<v-container fluid class="align-end">
			<v-row no-gutters>
				<v-spacer />
				<v-btn @click="onCancel" class="mr-2"> Cancel </v-btn>
				<v-btn color="primary" @click="onSubmit">
					<v-icon class="mr-2">mdi-content-save</v-icon>
					Submit
				</v-btn>
			</v-row>
		</v-container>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { AdminUserManagementActions } from '../../../store/actions';
import { AdminUserManagementGetters } from '../../../store/getters';
import EditUserFields from './EditUserFields.vue';
export default {
	name: 'AdminUserManagementEdit',
	components: { EditUserFields },
	data() {
		return {
			id: null,
			initialized: false,
		};
	},
	computed: {
		...mapGetters({
			selectedUser: [AdminUserManagementGetters.GET_SELECTED_USER],
		}),
	},
	mounted() {
		if (this.$route.params.id) {
			this.$store
				.dispatch(
					AdminUserManagementActions.LOAD_DATA_BYUSERID,
					this.$route.params.id
				)
				.then(() => {
					this.initialized = true;
				});
		} else {
			this.initialized = true;
		}
	},
	destroyed() {},
	methods: {
		onCancel() {
			this.$children[0].onCancel();
		},
		onSubmit() {
			this.$children[0].onSubmit();
		},
		cancel() {
			this.$router.push({
				name: 'UserManagement',
			});
		},
		submit(formUser) {
			if (formUser.Id) {
				this.$store
					.dispatch(AdminUserManagementActions.UPDATE, formUser)
					.then(() => {
						this.$router.push({ name: 'UserManagement' });
					});
			} else {
				this.initialized = false;
				this.$store
					.dispatch(AdminUserManagementActions.INSERT, formUser)
					.then(() => {
						this.$router
							.push({
								name: 'AdminUserManagementEdit',
								params: { id: this.selectedUser.Id },
							})
							.then(() => {
								this.initialized = true;
							});
					});
			}
		},
	},
};
</script>
